import styled from "styled-components";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Wrapper = styled.div`
    margin: ${theme.space[3]}px 0;
    padding: ${theme.space[2]}px;
    font-size: 1.3rem;
    text-align: right;
    background-color: ${theme.colors.grey1};
`;

export const Item = styled.div`
    display: inline-flex;
    align-items: center;
    width: 100%;
    max-width: 50%;

    .dxp-icon,
    svg {
        position: relative;
        top: 0;
        margin-right: ${theme.space[1]}px;
    }

    @media ${getBreakpoint("up", "md")} {
        width: auto;
        max-width: none;
        margin-right: ${theme.space[3]}px;
    }

    html[dir="rtl"] & {
        .dxp-icon,
        svg {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
        @media ${getBreakpoint("up", "md")} {
            margin-left: ${theme.space[3]}px;
            margin-right: 0;
        }
    }
`;
